import { twMerge } from 'tailwind-merge';

type TOverlayProps = {
    isShown?: boolean;
    onHide?: () => void;
    className?: string;
};

export const Overlay = ({ isShown = false, onHide, className }: TOverlayProps) => {
    return (
        <div
            className={twMerge(
                `fixed left-0 top-0 z-50 h-screen w-screen overflow-hidden ${
                    isShown ? 'block' : 'hidden'
                }`,
                className
            )}
            onClick={onHide}
        />
    );
};
